import { useState } from 'react'
import { message } from 'core/components/ui'
import { useIntl } from 'react-intl'
import Hydrator, { hydratorMethods } from 'core/hydrator'
import RequesterGlobal, { requesterGlobalMethods } from 'core/requesters/RequesterGlobal'
import { notification } from 'antd'

const useGetPointsOfSales = props => {
  const { redirectMessage } = props
  const [loadingPointsOfSales, setLoadingPointsOfSales] = useState(false)
  const [pointsOfSales, setPointsOfSales] = useState(null)
  const [loadingPointOfSales, setLoadingPointOfSales] = useState(false)
  const [pointOfSales, setPointOfSales] = useState(null)
  const [userCoordinates, setUserCoordinates] = useState(null)
  const [userZipcode, setUserZipcode] = useState(null)

  const intl = useIntl()

  const getUserGeolocation = params => {
    RequesterGlobal.get(requesterGlobalMethods.GET_USER_GEOLOCATION, params, redirectMessage)
      .then(datas => {
        if (datas.longitude && datas.latitude) {
          setUserCoordinates({
            longitude: datas.longitude,
            latitude: datas.latitude
          })
        } else {
          setUserCoordinates(null)
        }
      })
      .catch(e => {
        message.error(e)
      })
  }
  const getZipcodeByCoordinates = params => {
    RequesterGlobal.get(requesterGlobalMethods.GET_ZIPCODE_BY_COORDINATES, params, redirectMessage)
      .then(datas => {
        setUserZipcode(datas.zipCode)
      })
      .catch(e => {
        if (e.response.status === 404) {
          notification.error({
            message: intl.formatMessage({ id: 'error' }),
            description: intl.formatMessage({ id: 'error-zip-code' })
          })
        } else {
          message.error(e.response.statusText)
        }
      })
  }

  const getPointsOfSales = async params => {
    setLoadingPointsOfSales(true)
    return RequesterGlobal.get(requesterGlobalMethods.GET_POINTS_OF_SALES, params, redirectMessage)
      .then(datas => {
        setPointsOfSales(datas.items)
        return datas.items
      })
      .catch(e => message.error(e))
      .finally(() => {
        setLoadingPointsOfSales(false)
      })
  }

  const getPointOfSales = params => {
    setLoadingPointOfSales(true)
    RequesterGlobal.get(requesterGlobalMethods.GET_POINT_OF_SALES, params, redirectMessage)
      .then(datas => {
        const item = Hydrator.hydrate(hydratorMethods.HYDRATE_POINTOFSALES_FROM_CAR, {
          pointOfSale: { ...datas.pointOfSale }
        })

        setPointOfSales(item)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setLoadingPointOfSales(false)
      })
  }

  return {
    getUserGeolocation,
    userCoordinates,
    getZipcodeByCoordinates,
    userZipcode,
    getPointsOfSales,
    loadingPointsOfSales,
    pointsOfSales,
    getPointOfSales,
    loadingPointOfSales,
    pointOfSales
  }
}

export default useGetPointsOfSales
